<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Расчет стоимости выкупа
        </div>
        <div
          class="body-info__block">
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">
                Серийный номер
              </div>
              <div
                class="value">
                {{ model.sn }}
              </div>
            </div>
            <div
              class="info-table__line"
              v-for="(item, i) in model.device" :key="i"
              v-if="i != 'code' && i != 'type' && ((model.device['model']==null && i == 'fullName') || (model.device['model'] && i != 'fullName' )) && i != 'GPS' && i != 'cellular' && i != 'color' && item">
              <div
                class="label">
                {{ i == 'generation' ? 'Поколение' : i == 'model' ? 'Модель' : i == 'size' ? 'Размер' : i == 'fullName' ? 'Модель' : i }}
              </div>
              <div
                class="value">
                {{ item }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Грейд:
              </div>
              <div
                class="value">
                {{ grade }}
              </div>
            </div>
          </div>
          <div
            class="info-image">
            <div
              class="info-image__img">
              <img
                src="@/../static/img/image.jpg">
            </div>
            <div
              class="info-image__price">
              <div
                class="info-image__price-title">
                Стоимость устройства:
              </div>
              <div
                class="info-image__price-text">
                {{ price }} {{user.currency}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="next()">
        Продолжить
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('buymodels', ['model', 'price', 'answers','grade']),
    ...mapState('user', ['user'])
  },
  methods: {
    ...mapActions('buymodels', ['agreeModel']),

    async next() {
      const response = await this.agreeModel({
        btag: this.model.btag,
      });
      // this.$emit('changeScreen', {type: 'next', id: 2})
      this.$router.push(`/buyout/create?id=${this.model.btag}`);
    },
  }
}
</script>

<style lang="css">
</style>
